import request from "@/util/http";

// 列表		
export function findCouponEnable(query) {
	return request({
		url: '/marketing/shop/coupon/find_coupon_enable',
		method: 'get',
		params: query,
	})
}


// module.exports = {
// 	findCouponEnable
// }
